import NumberFormat from "react-number-format";
import { roleType } from "../../Utils/constant";
import { BlurWrapperWithSpan } from "../../Utils/CustomComponent";
import { useSelector } from "react-redux";

const MyLoanInvestmentTab = ({
  loanTerms,
  loanDetails,
  account_id,
  selectedRole,
  isABorrower = false,
}) => {
  const user = useSelector((state) => state.RS_Authentication.user);
  const achStatusHtml = document.createElement("div");
  achStatusHtml.innerHTML = loanDetails?.ach_status || "";
  const achStatus = achStatusHtml?.querySelector("strong")?.innerHTML || "";
  const isBroadviewAccount = user.details.email?.includes("broadview");

  return (
    <div className="row">
      <div className="col col-8 border-5">
        <div className="table table-bordered h-100">
          <table className="table table-borderless h-100">
            <tbody>
              <tr>
                <td className="fw-bold mb-5" colSpan="2">
                  Loan Info
                </td>
              </tr>
              <tr>
                {achStatus && (
                  <td
                    colSpan="2"
                    className="alert alert-danger mx-2 border"
                    style={{
                      backgroundColor: "#cce6e6",
                      borderColor: "#b3d9d9",
                    }}
                  >
                    <strong>
                      {selectedRole === roleType.borrower
                        ? achStatus
                        : achStatus
                            ?.replace("You", account_id)
                            ?.replace("do", "does")}
                    </strong>
                  </td>
                )}
              </tr>
              {!isABorrower ? (
                <tr>
                  <td>
                    <div> Loan No:</div>
                    <BlurWrapperWithSpan>
                      <div className="fw-bold">{account_id}</div>
                    </BlurWrapperWithSpan>
                  </td>
                  {selectedRole === roleType.broker ||
                  selectedRole === roleType.brokerAdmin ? (
                    <td>
                      <div> Amount Invested:</div>
                      <div className="fw-bold">
                        {loanDetails?.["loan_amount"]}
                      </div>
                    </td>
                  ) : (
                    <td>
                      <div> Borrower:</div>
                      <BlurWrapperWithSpan>
                        {/* <div className="fw-bold">{`${loanDetails?.["borrower_first_name"]} ${loanDetails?.["borrower_last_name"]}`}</div> */}
                        <div className="fw-bold">
                          {loanDetails?.borrower_name}
                        </div>
                      </BlurWrapperWithSpan>
                    </td>
                  )}
                </tr>
              ) : null}
              {(selectedRole !== roleType.broker ||
                selectedRole !== roleType.brokerAdmin) &&
                !isABorrower && (
                  <tr>
                    <td>
                      <div> Address:</div>
                      <BlurWrapperWithSpan>
                        <div className="fw-bold">
                          {loanDetails?.["borrower_address"]}
                        </div>
                      </BlurWrapperWithSpan>
                    </td>
                    <td>
                      <div> Amount Invested:</div>
                      <div className="fw-bold">
                        {loanDetails?.["loan_amount"]}
                      </div>
                    </td>
                  </tr>
                )}
              {!isABorrower ? (
                <tr>
                  {selectedRole === roleType.lender ||
                  selectedRole === roleType.lenderAdmin ? (
                    <>
                      <td>
                        <div> % of Loan Owned:</div>

                        <div className="fw-bold">
                          {loanDetails?.["Lender Ownership %"]} %
                        </div>
                      </td>
                      <td>
                        <div>My Interest Rate:</div>

                        <div className="fw-bold">
                          {loanDetails?.["Lender Rate"] || "-"}
                        </div>
                      </td>
                    </>
                  ) : null}

                  {/* {isBroadviewAccount && (
                    <td>
                      <div>Investor's Sold Rate:</div>

                      <div className="fw-bold">{loanTerms?.["Note Rate"]}</div>
                    </td>
                  )} */}
                </tr>
              ) : null}
              {!isABorrower ? (
                <tr>
                  <td>
                    <div>Late Charge Share:</div>
                    <div className="fw-bold">
                      {loanTerms?.["Late Charge Percent"]} %
                    </div>
                  </td>
                  <td>
                    <div>Monthly Servicing Fee:</div>
                    <div className="fw-bold">
                      {" "}
                      <NumberFormat
                        displayType="text"
                        value={loanDetails?.["Monthly Servicing Fee"]}
                        prefix={"$"}
                        customInput={false}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        thousandSeparator={true}
                      />
                    </div>
                  </td>
                </tr>
              ) : null}
              {!isABorrower ? (
                <tr>
                  <td>
                    <div>Current Unpaid Balance:</div>
                    <div className="fw-bold">
                      {loanDetails?.["unpaid_principal_balance"]}
                    </div>
                  </td>
                  <td>
                    <div>Current Total Amount Due:</div>
                    <div className="fw-bold">
                      {loanDetails?.["current_amount_due"] || " - "}
                    </div>
                  </td>
                </tr>
              ) : null}

              {(selectedRole === roleType.broker ||
                selectedRole === roleType.brokerAdmin ||
                isABorrower) && (
                <>
                  <tr>
                    <td>
                      <div> Borrower Name:</div>
                      <BlurWrapperWithSpan>
                        {/* <div className="fw-bold">{`${loanDetails?.["borrower_first_name"]} ${loanDetails?.["borrower_last_name"]}`}</div> */}
                        <div className="fw-bold">
                          {loanDetails?.borrower_name}
                        </div>
                      </BlurWrapperWithSpan>
                    </td>
                    <td>
                      <div>Borrower Address:</div>
                      <BlurWrapperWithSpan>
                        <div className="fw-bold">
                          {`${loanDetails?.["borrower_address"]}, ${loanDetails?.["borrower_city"]} ${loanDetails?.["borrower_state"]}, ${loanDetails?.["borrower_zip_code"]}`}
                        </div>
                      </BlurWrapperWithSpan>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div> Borrower Email:</div>
                      <BlurWrapperWithSpan>
                        <div className="fw-bold">{`${loanDetails?.["borrower_email"]}`}</div>
                      </BlurWrapperWithSpan>
                    </td>
                    <td>
                      <div>Home Phone:</div>
                      <BlurWrapperWithSpan>
                        <div className="fw-bold">
                          {loanDetails?.["borrower_home_phone"]}
                        </div>
                      </BlurWrapperWithSpan>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div> Mobile Phone:</div>
                      <BlurWrapperWithSpan>
                        <div className="fw-bold">{`${loanDetails?.["borrower_mobile_phone"]}`}</div>
                      </BlurWrapperWithSpan>
                    </td>
                    <td>
                      <div>Work Phone:</div>
                      <BlurWrapperWithSpan>
                        <div className="fw-bold">
                          {loanDetails?.["borrower_work_phone"]}
                        </div>
                      </BlurWrapperWithSpan>
                    </td>
                  </tr>
                  {isABorrower ? (
                    <tr>
                      <td>
                        <div>Current Unpaid Balance:</div>
                        <div className="fw-bold">
                          {loanDetails?.["unpaid_principal_balance"]}
                        </div>
                      </td>
                      <td>
                        <div>Current Total Amount Due:</div>
                        <div className="fw-bold">
                          {loanDetails?.["current_amount_due"]}
                        </div>
                      </td>
                    </tr>
                  ) : null}
                </>
              )}
              {selectedRole === roleType.broker ||
              selectedRole === roleType.brokerAdmin ? (
                <tr>
                  <td>
                    <div>Note Rate / Sold Rate</div>
                    <div className="fw-bold">
                      {loanDetails?.["Investor Rate"] || "-"}
                    </div>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col border-1">
        <div className="table table-bordered h-100">
          <table className="table table-borderless h-100">
            <tbody>
              <tr>
                <td className="fw-bold mb-5" colSpan="2">
                  Payment Info
                </td>
              </tr>
              <tr>
                <td>Loan Amount:</td>
                <td className="fw-bold">{loanDetails?.["loan_amount"]}</td>
              </tr>
              <tr>
                <td>UPB:</td>
                <td className="fw-bold">
                  {loanDetails?.["unpaid_principal_balance"]}{" "}
                </td>
              </tr>
              <tr>
                <td>Payoff Date:</td>
                <td className="fw-bold">
                  {loanDetails?.["Payoff Date"] || "-"}
                </td>
              </tr>
              <tr>
                <td>Maturity Date:</td>
                <td className="fw-bold">{loanDetails?.["Maturity"]}</td>
              </tr>
              <tr>
                <td>Next Due Date:</td>
                <td className="fw-bold">{loanDetails?.["next_due_date"]}</td>
              </tr>
              <tr>
                <td>Monthly P&I Due:</td>
                <td className="fw-bold">{loanTerms?.["Pmt PI"]}</td>
              </tr>
              <tr>
                <td>Reserve Balance:</td>
                {/* <td className="fw-bold">{loanTerms?.["Pmt Reserve"]}</td> */}
                <td className="fw-bold">{loanDetails["balance_reserve"]}</td>
              </tr>
              <tr>
                <td>Impound Balance:</td>
                {/* <td className="fw-bold">{loanTerms?.["Pmt Impound"]}</td> */}
                <td className="fw-bold">{loanDetails["balance_impound"]}</td>
              </tr>
              <tr>
                <td>Reserve Payment:</td>
                <td className="fw-bold">{loanTerms?.["Pmt Reserve"]}</td>
              </tr>
              <tr>
                <td>Impound Payment:</td>
                <td className="fw-bold">{loanTerms?.["Pmt Impound"]}</td>
              </tr>
              <tr>
                <td>Unpaid Late Charges:</td>
                <td className="fw-bold">
                  {loanDetails?.["unpaid_late_charges"]}
                </td>
              </tr>
              <tr>
                <td>Unpaid Interest:</td>
                <td className="fw-bold"> {loanDetails?.["unpaid_interest"]}</td>
              </tr>
              <tr>
                <td>Other Charges:</td>
                <td className="fw-bold">{loanTerms?.["Pmts Other"]}</td>
              </tr>
              <tr>
                <td>Total Payment:</td>
                <td className="fw-bold">
                  {loanTerms?.["Total Regular Payment"]}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default MyLoanInvestmentTab;
